import React from "react";
import { v4 as uuidv4 } from "uuid";
import { ControlPanel } from "./ControlPanel";
import { PreviewPlayer } from "./PlayerPreview";
import { PlayerDevice } from "./Player";
import { GrStrikeThrough } from "react-icons/gr";
import { AddPreview } from "./AddPreview/AddPreview";
export const ScrollWidget = {
    id: "7f43d728-c6b0-4888-b236-efedd2433451",
    name: "Défilement",
    icon: React.createElement(GrStrikeThrough, null),
    type: "scroll",
    inHeadbar: true,
    description: "Edit scroll text (font, size, color, etc.)",
    keywords: ["texte", "scroll", "défilement", "defilement", "boucle"],
    config: null,
    createdAt: "2022-06-12T08:09:00.000Z",
    updatedAt: "2022-06-12T08:09:00.000Z",
    isActive: true,
    isDeleted: false,
    load: null,
    scope: ["font"],
    controlPanel: ControlPanel,
    playerPreview: PreviewPlayer,
    context: null,
    playerDevice: PlayerDevice,
    contextDevice: ({ children }) => React.createElement(React.Fragment, null, children),
    addWidgetPreview: [AddPreview],
    height: "auto",
    factory: (params) => {
        var _a;
        const screenHeight = (_a = params === null || params === void 0 ? void 0 : params.screenHeight) !== null && _a !== void 0 ? _a : 1920;
        return {
            id: uuidv4(),
            data: {
                text: "",
                font: "Lobster",
                size: Math.round(screenHeight * 0.05),
                fontWeight: 400,
                textColor: "#ffffff",
                backgroundColor: "#33333300",
                scrollSpeed: 3,
            },
        };
    },
    resize: {
        bottom: false,
        bottomLeft: false,
        bottomRight: false,
        left: true,
        right: true,
        top: false,
        topLeft: false,
        topRight: false,
    },
};
